import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BuscaTramiteService } from "../../servicios/busca-tramite.service";
import { ActivatedRoute } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import {
  BuscaTramite,
  BuscaTramiteInput,
  SolicitudEtapaTramites,
  Solicitudes,
  AuxJasper,
  ParametroJasper,
} from "../../entidades/entidades";
import { Observable, empty } from "rxjs";
import { SolicitudesService } from "../../servicios/solicitudes.service";
import { Router } from "@angular/router";
import { SolicitudEtapaTramitesService } from "../../servicios/solicitud-etapa-tramites.service";
import { JasperService } from "../../servicios/jasper.service";
import { CatMotivoLevantamientosGridComponent } from '../cat-motivo-levantamientos-grid/cat-motivo-levantamientos-grid.component';
import { DatePipe } from "@angular/common";
import { MessageService } from 'primeng/api';
import * as XLSX from 'xlsx';

declare var $: any;

@Component({
  selector: "app-busca-tramite",
  templateUrl: "./busca-tramite.component.html",
  styleUrls: ["./busca-tramite.component.css"],
})
export class BuscaTramiteComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  buscaTramiteForm: FormGroup;
  ejecucion: boolean = false;
  currentUser: any;
  buscando: boolean = false;
  usuario: any;
  msgs: any;
  /*  fecha = Date.now();  */

  @Input("buscaTramite") buscaTramite: BuscaTramiteInput;
  @Output("buscaTramiteOutput") buscaTramiteOutput: EventEmitter<BuscaTramite>;
  @ViewChild('SolicitudInput') SolicitudInput!: ElementRef;

  buscaTramiteTable: BuscaTramite[];
  selectedbuscaTramite: BuscaTramite[];

  public tableWidget: any;
  public tramite: BuscaTramite;
  public SolicitudEtapaTramites: SolicitudEtapaTramites;
  public solicitudes: Solicitudes;
  private _jasperService: JasperService;
  public auxJasper: AuxJasper;
  public tramiteTabla: BuscaTramite[];

  public numSolicitud: number;

  //Criterios de busqueda
  public cuenta:number;
  public nombre:string;
  public apellidoP:string;
  public apellidoM:string;
  public razonSocial:string;
  public fechaIni:Date;
  public fechaFin:Date;
  mensaje: boolean = false;
  cols: any[];
  exportColumns: any[];

  @Input() es_caja: boolean;
  busca_tramite_fechaDe: any;
  first = 0;

  mostrar = false;
  showdialog() {
     this.mostrar = true;
     if (this.buscaTramiteTable)
       this.buscaTramiteTable.splice(0);
   }

  constructor(
    private formBuilder: FormBuilder,
    private buscaTramiteService: BuscaTramiteService,
    private SolicitudesService: SolicitudesService,
    private SolicitudEtapaTramitesService: SolicitudEtapaTramitesService,
    private jasp: JasperService,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService:AuthenticationService,
    private messageService: MessageService,
  ) {
    /*    this.busca_tramite_fechaDe.fechaDe({ descripcion: 'fecha' }) */
    this.buscaTramiteOutput = new EventEmitter();
    this._jasperService = jasp;
  }

  async ngOnInit() {
    await this.authenticationService.getUserByToken();
    this.usuario = this.authenticationService.currentUserValue;

    this.buscaTramiteForm = this.formBuilder.group({
      numSolicitud: [undefined],
      cuentaAgua: [undefined],
      fechaDe: [undefined],
      fechaHasta: [undefined],
      nombre: [undefined],
      pApellido: [undefined],
      sApellido: [undefined],
      razonSocial: [undefined],
    });
    this.cargafechas();
    if (this.buscaTramite) this.buscaTramiteForm.patchValue(this.buscaTramite);
    
    this.cols = [
      { field: 'cuentaAgua', header: 'Cuenta' },
      { field: 'numSolicitud', header: 'Solicitud' },
      { field: 'concepto', header: 'Concepto' },
      { field: 'fecha', header: 'Fecha' },
      { field: 'solicitante', header: 'Solicitante' },
      { field: 'estadoTramite', header: 'Estado Tramite' },
      { field: 'estatusPago', header: 'Estatus Pago' },
      { field: 'monto', header: 'Monto' }
    ];
  
    this.exportColumns = this.cols.map(col => ({title: col.header, dataKey: col.field}));

  }
  ngAfterViewInit() {
    if (this.SolicitudInput) {
      this.SolicitudInput.nativeElement.focus();
    }
  }
  async cargafechas() {
    var date = new Date(new Date());
    var dayActual = date.getDate().toString().padStart(2, "0");
    var monthIndexActual = (date.getMonth() + 1).toString().padStart(2, "0");
    var yearActual = date.getFullYear();
    var fecha_act =
      yearActual.toString() +
      "-" +
      monthIndexActual.toString() +
      "-" +
      dayActual.toString();

  }

  

  async getTramite() 
  {
    if(!this.numSolicitud)
    {
      await this.muestraMensaje.error(
        "Debes de capturar un numero de solicitud",
        "top",
        "center"
      );
      return;
    }
    let buscaTramite = new BuscaTramiteInput();
    buscaTramite.esCaja = this.es_caja;
    buscaTramite.numSolicitud = this.numSolicitud;
    console.log("Va al servicio: ", buscaTramite);
    const datoRetorno = await this.buscaTramiteService
        .getBusquedas(buscaTramite)
        .toPromise();
    console.log("Detalle", datoRetorno);
    this.tramiteTabla = datoRetorno;

    if (this.tramiteTabla[0] != null) {
      this.buscaTramiteOutput.emit(this.tramiteTabla[0]);
    } else {
      await this.muestraMensaje.error(
        "No se encontró información",
        "top",
        "center"
      );
      
      this.limpia();
    }
  }

  async busca()
  {

    try {
      this.buscando = true;
      this.first = 0;
      this.messageService.clear();
      if(this.buscaTramiteTable)
        this.buscaTramiteTable.splice(0);
  
      let tramiteInput = new BuscaTramiteInput();
      tramiteInput.cuentaAgua = this.cuenta;
      tramiteInput.esCaja = this.es_caja;
      tramiteInput.Nombre = this.nombre;
      tramiteInput.PApellido = this.apellidoP;
      tramiteInput.SApellido = this.apellidoM;
      tramiteInput.RazonSocial = this.razonSocial;
      tramiteInput.fechaDe = this.fechaIni;
      tramiteInput.fechaHasta = this.fechaFin;
      
      if(!this.fechaIni  )
        if( this.fechaFin != null)
        throw new Error('Debes capturar dos rangos de fecha.');
      
      if(this.fechaFin === null)
        if(this.fechaIni != null)
          throw new Error('Debes capturar dos rangos de fecha.');
      
      
      console.log('Busca', tramiteInput);
      const datoRetorno = await this.buscaTramiteService
        .getBusquedas(tramiteInput)
        .toPromise();
      console.log("Detalle : ", datoRetorno);
  
      if (datoRetorno[0] == null || !datoRetorno) 
        throw new Error('No se encontraron resultados para esta combinación de búsqueda.');

      this.buscaTramiteTable = datoRetorno;
      this.auxJasper = null;
      this.messageService.clear();
      this.limpia();

    } catch (e) {

      await this.Mensaje(e);
      await this.limpia();
      this.buscando = false;

    } finally {
      console.log("Paso por Buscar");
      this.buscando = false;
    }
    
  }

  async Mensaje(e:any) {
    this.mensaje = true;
    this.messageService.clearObserver;
    this.messageService.add({ severity: 'warn', summary: e.message, detail: '.' });
  }

  async selectRow(row: any) {
    try {
      const eje = document.getElementsByName("modulo");
      if (eje[0].id == "ejecucion") this.ejecucion = true;
      console.log("Renglon seleccionado:", row);

      // en ejecucion
      if (this.ejecucion) {
        if (row.rutaPagina != null) {
          //this.buscaTramiteOutput.emit(row);
          if (row.rutaPagina == "comercializacion/contratos") {
            this.router.navigate([row.rutaPagina + "/" + row.id]);
          } else {
            this.router.navigate([row.rutaPagina]);
          }
          console.log("Ruta: ", row.rutaPagina + "/" + row.id);
          //this.router.navigate([row.rutaPagina]);
        } else {
          this.muestraMensaje.notification(
            "Su trámite fue concluido.",
            "top",
            "center"
          );
        }
        // $("#exampleModalLong").modal("hide");
        this.mostrar = false;
      }
      //en informacion
      else {
        this.auxJasper = null;
        this.buscaTramiteOutput.emit(row);
        this.tramite = row;
        // $("#exampleModalLong").modal("hide");
        this.mostrar = false;
      }

      console.log("Tramite:", this.tramite);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getBuscaTramite");
    }
  }

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  
  async onKeydown(event) {
    if (event.key === "Enter") {
      console.log(event);
    }
    if(!this.numSolicitud)
    {
      await this.muestraMensaje.error(
        "Debes de capturar un numero de solicitud",
        "top",
        "center"
      );
      return;
    }
    console.log(this.numSolicitud);

    let buscaTramite = new BuscaTramiteInput();
    buscaTramite.esCaja = this.es_caja;
    buscaTramite.numSolicitud = this.numSolicitud;
      console.log("Va al servicio: ", buscaTramite);
      const datoRetorno = await this.buscaTramiteService
        .getBusquedas(buscaTramite)
        .toPromise();
    console.log("Detalle", datoRetorno);
    this.tramiteTabla = datoRetorno;

      if (this.tramiteTabla[0] != null) {
        this.buscaTramiteOutput.emit(this.tramiteTabla[0]);
      } else {
        await this.muestraMensaje.error(
          "No se encontró información",
          "top",
          "center"
        );
        //this.buscaTramiteOutput.emit(null);
        this.limpia();
      }
  }

  async getBuscaTramite(BuscaTramite: BuscaTramiteInput) {
    try {
      BuscaTramite.esCaja = this.es_caja;
      console.log("Va al servicio: ", BuscaTramite);
      const datoRetorno = await this.buscaTramiteService
        .getBusquedas(BuscaTramite)
        .toPromise();
      console.log("Detalle", datoRetorno);
      this.tramiteTabla = datoRetorno;
      this.buscaTramiteTable = this.tramiteTabla;
      this.auxJasper = null;

      //this.reInitDatatable();
      this.limpia();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getBuscaTramite");
    }
  }

  // ngAfterViewInit() {
  //   this.initDatatable();
  // }

  /*   var table = $('#example').DataTable();
 
$('#container').css( 'display', 'block' );
table.columns.adjust().draw(); */
  /* Edicion de datatable */

  // private initDatatable(): void {
  //   const tabla: any = $("#tablaBuscaTramite");
  //   this.tableWidget = tabla.DataTable({
  //     /*  "dom": '<"top"i>rt<"bottom"flp><"clear">', */
  //     // Se ocultaton registros
  //     dom: '<"toolbar">frtip',

  //     columnDefs: [
  //       { className: "dt-left", targets: "_all" },
  //       /*  { "visible": false,  "targets": [ 3 ] } */
  //     ],
  //     fixedColumns: true,
  //     stateSave: false,
  //     paging: true,
  //     info: false,
  //     scrollX: true,
  //     scrollY: false,
  //     destroy: true,
  //     searching: false,
  //     ordering: true,
  //     autoWidth: false,
  //     language: {
  //       sProcessing: "Procesando...",
  //       sLengthMenu: "Mostrar _MENU_ registros",
  //       sZeroRecords: "No se encontraron resultados",
  //       sEmptyTable: "Ningún dato disponible en esta tabla",
  //       sInfo:
  //         "Registros del _START_ al _END_ de un total de _TOTAL_ registros",
  //       sInfoEmpty: "Registros del 0 al 0 de un total de 0 registros",
  //       sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
  //       sInfoPostFix: "",
  //       sSearch: "Buscar:",
  //       sUrl: "",
  //       sInfoThousands: ",",
  //       sLoadingRecords: "Cargando...",
  //       oPaginate: {
  //         sFirst: "Primero",
  //         sLast: "Último",
  //         sNext: "Siguiente",
  //         sPrevious: "Anterior",
  //       },
  //       oAria: {
  //         sSortAscending:
  //           ": Activar para ordenar la columna de manera ascendente",
  //         sSortDescending:
  //           ": Activar para ordenar la columna de manera descendente",
  //       },
  //       buttons: {
  //         copy: "Copiar",
  //         colvis: "Visibilidad",
  //       },
  //       dom: '<"top"iflp<"clear">>rt<"bottom"iflp<"clear">>',
  //     },
  //     /* filtrar el numero de registros mostrados en pantalla */
  //     lengthMenu: [[7], [7]],
  //   });
  // }
  // private reInitDatatable(): void {
  //   this.tableWidget.destroy();
  //   // this.tableWidget = null;
  //   setTimeout(() => this.initDatatable(), 0);
  // }

  async getAllBuscaTramite() {
    try {
      const datoRetorno = await this.buscaTramiteService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllBuscaTramite");
    }
  }
  async limpia() 
  {
    try 
    {
      this.cuenta=null;
      this.nombre=null;
      this.apellidoP=null;
      this.apellidoM=null;
      this.razonSocial=null;
      this.fechaIni=null;
      this.fechaFin=null;
      this.numSolicitud = null;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }

  exportarXLSX(){
    const data = this.buscaTramiteTable.map(row => ({
      'Cuenta': row.cuentaAgua,
      'Solicitud': row.numSolicitud,
      'Concepto': row.concepto,
      'Fecha': row.fecha,
      'Solicitante': row.solicitante,
      'Estado Tramite': row.estadoTramite,
      'Estatus Pago': row.estatusPago,
      'Monto': row.monto
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

  const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
  const blob = new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'SeguimientoTramite(BusquedaPersonalizad).xlsx';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  }

  s2ab(s){
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }
}


  



